module.exports = __webpack_public_path__ + "img/carrossel.1c8e460d.webp";